import React from 'react';
import Hero from '../components/Hero';
import SearchFilter from '../components/SearchFilter';
import FeaturedVehicles from '../components/FeaturedVehicles';
import FeaturedParts from '../components/FeaturedParts';
import RecentVehicles from '../components/RecentVehicles';
import WhyChooseUs from '../components/WhyChooseUs';
import Testimonials from '../components/Testimonials';
import CtaBanner from '../components/CtaBanner';
import FaqSection from '../components/FaqSection';
import MembershipUpsell from '../components/MembershipUpsell';
import useSEO, { faqLd } from '../hooks/useSEO';

const HOME_FAQS = [
  { q: 'Where is Timeless Auto Imports located in Jamaica?', a: 'Lot 36 Bustamante Highway, Four Path, Clarendon — just outside May Pen. We serve customers across Jamaica with free delivery in Kingston and St. Andrew.' },
  { q: 'Do you sell used Japanese cars in Jamaica?', a: 'Yes. We specialise in premium pre-owned Japanese imports — Toyota, Honda, Nissan, Mazda, Subaru, Suzuki, Daihatsu, BMW and Mercedes — all inspected and serviced before delivery.' },
  { q: 'Do you offer hybrid battery replacement and hybrid mechanic services?', a: 'Yes. Our workshop is trained in hybrid vehicle diagnostics, hybrid battery replacement, inverter and cell repairs for Toyota, Honda and Lexus hybrids.' },
  { q: 'Where can I buy genuine auto parts in Jamaica?', a: 'Browse our online Parts & Accessories store or visit the shop in Four Path, Clarendon. We stock filters, brake pads, hybrid components, body panels and accessories, with island-wide delivery via Knutsford Express.' },
  { q: 'Do you deliver cars and parts across Jamaica?', a: 'Yes — free delivery in Kingston & St. Andrew, and island-wide delivery via Knutsford Express to any parish.' },
];

export default function Home() {
  useSEO({
    title: "Used Japanese Cars & Auto Parts in Jamaica — Don't Just Dream it, Drive it.",
    description: 'Premium pre-owned Japanese vehicles, hybrid mechanic service, genuine auto parts and accessories. Based in Four Path, Clarendon — free delivery in Kingston & St. Andrew, island-wide via Knutsford.',
    path: '/',
    jsonLd: faqLd(HOME_FAQS),
    jsonLdKey: 'home-faq',
  });
  return (
    <>
      <Hero />
      <MembershipUpsell />
      <FeaturedParts />
      <SearchFilter />
      <FeaturedVehicles />
      <WhyChooseUs />
      <RecentVehicles />
      <Testimonials />
      <FaqSection
        eyebrow="FAQ"
        title="Everything you might be wondering."
        subtitle="Answers to the most common questions we get about buying, servicing, and repairing cars in Jamaica."
        items={HOME_FAQS}
        testId="home-faq"
      />
      <CtaBanner />
    </>
  );
}
